import React from 'react';

import styles from './ConsultationRecordShell.module.css';

export type ConsultationRecordShellProps = {
  breadcrumb?: React.ReactNode;
  header?: React.ReactNode;
  setup?: React.ReactNode;
  sidebar?: React.ReactNode;
  coreFields?: React.ReactNode;
  structuredFields?: React.ReactNode;
  actionBar?: React.ReactNode;
  className?: string;
};

export const ConsultationRecordShell: React.FC<ConsultationRecordShellProps> = ({
  breadcrumb,
  header,
  setup,
  sidebar,
  coreFields,
  structuredFields,
  actionBar,
  className,
}) => (
  <div className={[styles.recordPage, className].filter(Boolean).join(' ')}>
    {breadcrumb}
    {header}
    {setup}
    <div className={sidebar ? styles.recordLayout : undefined}>
      <div className={styles.recordMain}>
        {coreFields}
        {structuredFields}
      </div>
      {sidebar ? <aside className={styles.recordSidebar}>{sidebar}</aside> : null}
    </div>
    {actionBar}
  </div>
);

export default ConsultationRecordShell;
